// extracted by mini-css-extract-plugin
export var container = "_ig-0";
export var segment = "_ig-2";
export var segmentActive = "_ig-3";
export var track = "_ig-1";